const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
};

const setCookie = (name, value, custom = {}) => {
    const options = {
        path: '/',
        ...custom,
    };

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (options.expires instanceof Date) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        options.expires = options.expires.toUTCString();
    }

    let updatedCookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

    // eslint-disable-next-line no-restricted-syntax, guard-for-in
    for (const optionKey in options) {
        updatedCookie += `; ${optionKey}`;
        const optionValue = options[optionKey];

        if (optionValue !== true) {
            updatedCookie += `=${optionValue}`;
        }
    }

    document.cookie = updatedCookie;
};

const getDomain = () => {
    const { hostname } = document.location;
    let domain = '';
    const domainLevel = 3;

    if (hostname === 'localhost') {
        domain = 'localhost';
    } else {
        domain = `.${hostname.split('.').reverse().splice(0, domainLevel).reverse().join('.')}`;
    }
    return domain;
};

const getHash = (str) => {
    const FIRST_CONST = 4294967295; // 11111111111111111111111111111111 | 1 x 32 | 0 x 0
    const SECOND_CONST = 4278190080; // 11111111000000000000000000000000 | 1 x 8  | 0 x 24
    const UNITS = 8 - 1; // units count - 1
    const ZEROS = 24; // zeros count
    const DIFF = ZEROS - UNITS - 1; // zeros and units diff - 1
    let hash = 1;
    let code = 0;

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < str.length; i++) {
        code = str.charCodeAt(i);
        // eslint-disable-next-line no-bitwise
        hash = ((hash << UNITS) & FIRST_CONST) + (code << DIFF) + code;
        // eslint-disable-next-line no-bitwise
        code = hash & SECOND_CONST;

        if (code !== 0) {
            // eslint-disable-next-line no-bitwise
            hash ^= code >> ZEROS;
        }
    }

    return hash;
};

const generatePubId = (ver) => {
    const str =
        window.navigator.userAgent +
        document.cookie +
        document.referrer +
        window.innerWidth +
        window.innerHeight +
        Math.random().toString(36).substr(2, 9);
    const hashStr = getHash(str);
    const date = +new Date();

    return [ver, hashStr, date].join('.');
};

export const initTop100Counter = () => {
    const cookieName = 'stat_pubId';
    let pubId = getCookie(cookieName);

    if (!pubId) {
        pubId = generatePubId('stat1');
        setCookie(cookieName, pubId, { domain: getDomain() });
    }

    // eslint-disable-next-line no-underscore-dangle
    (window._top100q = window._top100q || []).push(() => {
        const options = {
            project: 7715095,
            pub_scope: 'ads.sber.ru',
            pub_id: pubId || '',
        };

        try {
            window.sberAdsCounter = new window.top100(options); // eslint-disable-line new-cap
        } catch (e) {
            console.error('Не удалось инициализировать счётчик ТОП-100', e); // eslint-disable-line no-console
        }
    });
};

export const initTop100Popular = () => {
    if (!__PROD_RENDER__) return

    // eslint-disable-next-line no-underscore-dangle
    (window._top100q = window._top100q || []).push(() => {
        const options = {
            project: 7750449,
        };

        try {
            window.popularCounter = new window.top100(options); // eslint-disable-line new-cap
        } catch (e) {
            console.error('Не удалось инициализировать счётчик ТОП-100', e); // eslint-disable-line no-console
        }
    });    
}

export const sendEvent = (...args) => {
    window.sberAdsCounter?.trackEvent?.(...args);
};
